import React, { useState } from 'react';
import { Flex, Form, Switch, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { RcFile } from 'antd/lib/upload';
import { FormInstance } from 'antd/es/form';

import CardFormInput from '../CardForms/CardFormInput';

import { GiidePublishStateObj, SettingsData } from '../../types';
import { handleInputChange } from '../utils';

import CardFormTextArea from '../CardForms/CardFormTextArea';

interface IProps {
  giideData: SettingsData;
  detailsForm: FormInstance;
  progress: number;
  avatar: string | null;
  updateSpeakerInput: (key: string, value: string) => void;
  updateSpeakerUrlInput: (key: string, vlaue: string) => void;
  updateSpeakerName: (fullName: string) => void;
  handleUpload: (file: RcFile) => Promise<void>;
  removeAvatar: () => void;
  publishing?: GiidePublishStateObj;
  updateGiideInput: (key: string, vlaue: string) => void;
  saving?: boolean;
  updateGiideTitleName: (newTitle: string) => void;
  toggleNoIndex: () => void;
  noIndexLoading: boolean;
}

const DetailsSettings: React.FC<IProps> = ({
  giideData,
  detailsForm,
  progress,
  avatar,
  updateSpeakerInput,
  updateSpeakerUrlInput,
  updateSpeakerName,
  handleUpload,
  removeAvatar,
  publishing,
  updateGiideInput,
  saving,
  updateGiideTitleName,
  toggleNoIndex,
  noIndexLoading,
}) => {
  const [speakerName, setSpeakerName] = useState<string>(
    giideData.speaker.fullName
  );

  return (
    <Flex
      vertical={true}
      justify={'center'}
      align={'center'}
      style={{ height: 350 }}
    >
      <Form
        layout="vertical"
        requiredMark={false}
        autoComplete="off"
        form={detailsForm}
        style={{ width: '100%' }}
      >
        <CardFormInput
          name="titleGiide"
          fieldLabel="Title"
          defaultValue={giideData.title}
          maxLength={60}
          placeholder="Title"
          onChange={handleInputChange(value => updateGiideTitleName(value))}
          disabled={saving}
          required={false}
        />

        <CardFormInput
          name="author"
          fieldLabel="Author"
          defaultValue={speakerName}
          maxLength={60}
          placeholder="Author"
          onChange={e => setSpeakerName(e.target.value)}
          onBlur={e => updateSpeakerName(speakerName)}
          disabled={saving}
          required={false}
        />

        <CardFormTextArea
          name="description"
          fieldLabel="Summary"
          className="giideSummary"
          defaultValue={giideData.description}
          rows={3}
          showCount
          maxLength={800}
          onChange={handleInputChange(value =>
            updateGiideInput('description', value)
          )}
          placeholder="Title, company optional"
          disabled={saving}
          required={false}
        />
      </Form>

      <Flex
        justify={'space-between'}
        gap={'middle'}
        style={{ alignSelf: 'flex-start' }}
      >
        <Flex align={'center'} justify={'flex-start'} gap={'small'}>
          <div>Search engine indexing:</div>
          <Tooltip
            placement="bottom"
            title="When turned on, search engine crawlers are able to find your giide
              which helps drive traffic and awareness to it. Giides are crawled
              like a standard web page, including the title, author,
              description, and feedcard contents."
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </Flex>

        <Switch
          size="default"
          onChange={toggleNoIndex}
          checkedChildren={'On'}
          unCheckedChildren={'Off'}
          defaultChecked={!giideData.noindex}
          checked={!giideData.noindex}
          disabled={noIndexLoading}
          loading={noIndexLoading}
        />
      </Flex>
    </Flex>
  );
};

export default DetailsSettings;
